import { useMe } from '@crehana/auth';
import { useTranslation } from '@crehana/i18n';

import { getCardsData } from './constants';
import type { Card, Profile, Talent } from './types';

const useHomeData = ({
  slug,
}: {
  slug: string;
}): {
  profile: Profile | undefined;
  talent: Talent;
  cards: Card[];
  loading: boolean;
} => {
  const { t } = useTranslation();
  const { me, talentUser } = useMe();

  const { loading, talentModules } = talentUser;

  const recognitionModuleUrl = talentModules
    .find(m => m.code === 'RECOGNITION')
    ?.submodules.find(sub => sub.code === 'RECOGNITION')?.url;
  const goalsModuleUrl = talentModules
    .find(m => m.code === 'PERFORMANCE')
    ?.submodules.flatMap(s => s.submodules)
    .find(sub => sub.code === 'GOALS' || sub.code === 'OKRS')?.url;
  const resultsModuleUrl = talentModules
    .find(m => m.code === 'ANALYTICS')
    ?.submodules.find(sub => sub.code === 'COLLABORATOR_RESULTS')?.url;

  const cards = getCardsData(t, slug);

  return {
    loading,
    profile: {
      profileUrl: me?.profileUrl || '',
      profileImageUrl: me?.profilePictureUrl || '',
      fullName: me?.fullName || '',
      occupation: talentUser.job,
      department: talentUser.subsidiary,
      bossName: talentUser.bossFullName,
      location: talentUser.subsidiary,
    },
    talent: {
      // @ts-expect-error Validate with filter predicate
      modules: [
        recognitionModuleUrl && {
          label: 'Reconocimientos',
          description:
            'Envía medallas a tus compañeros para reconocer su labor.',
          url: recognitionModuleUrl,
        },
        goalsModuleUrl && {
          label: 'Objetivos',
          description:
            'Registra tus métricas y su progreso para el cumplimiento de los objetivos.',
          url: goalsModuleUrl,
        },
        resultsModuleUrl && {
          label: 'Resultados',
          description:
            'Consulta los resultados de los procesos en los que participas.',
          url: resultsModuleUrl,
        },
      ].filter(module => module),
    },
    cards,
  };
};

export default useHomeData;
